// src/components/common/Loader/UserTableSkeleton.jsx
import React from 'react';
import { Skeleton, TableRow, TableCell } from '@mui/material';

const UserTableSkeleton = ({ rows = 10, columns = 10 }) => {
  return (
    <>
      {[...Array(rows)].map((_, rowIndex) => (
        <TableRow key={rowIndex}>
          {[...Array(columns)].map((_, colIndex) => (
            <TableCell key={colIndex} align="center">
              <Skeleton
                variant="rounded"
                height={20}
                width="80%"
                sx={{ mx: 'auto', borderRadius: 1 }}
              />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
};

export default UserTableSkeleton;
